import getFromCdn from '@anm/helpers/getFromCdn';
import {
  dashboardDescriptionStyles,
  dashboardTitleBlockStyles,
  media,
  myProjectsItemBottomStyles,
  stretchBlock
} from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export type TitleVariant = 'black' | 'gray';

const FolderWrapperAdaptiveStyles = media.tablet`
    max-width: 100%;
`;

export const FolderWrapper = styled.div`
  max-width: 280px;
  ${FolderWrapperAdaptiveStyles};
`;

export const FolderBottom = styled.div`
  ${myProjectsItemBottomStyles};
  position: relative;
  background-color: #fff;
  box-shadow: 0 1px 5px rgba(41, 42, 43, 0.1);
`;

const FolderPreviewAdaptiveStyles = media.tablet`
  height: 0;
  padding-top: 100%;
  background-size: contain;
  position: relative;
  img {
      position: absolute;
      top: 13.125%;
      left: 7.5%;
      max-width: 85%;
  }
`;

export const FolderPreview = styled.div`
  background: url(${getFromCdn('images/dashboard/folder.svg')}) no-repeat 0 0 transparent;
  background-size: cover;
  cursor: pointer;
  padding: 36px 19px 0 19px;
  height: 280px;
  width: 100%;
  clip-path: polygon(47% 0, 54% 7%, 100% 7%, 100% 100%, 0 100%, 0 0);
  img {
    max-width: 100%;
  }
  &:hover {
    &:after {
      ${stretchBlock};
      content: '';
      background-color: rgba(32, 171, 210, 0.3);
    }
  }
  ${FolderPreviewAdaptiveStyles};
`;

const titleVariants: { [key in TitleVariant]: ReturnType<typeof css> } = {
  black: dashboardTitleBlockStyles('#292a2b'),
  gray: dashboardTitleBlockStyles('#919eaa')
};

export const FolderTitleBlock = styled.div<{ variant: TitleVariant }>`
  ${({ variant }) => titleVariants[variant]};
`;

export const FolderDescription = styled.p`
  ${dashboardDescriptionStyles};
  margin-top: 6px;
`;

export const FolderDescriptionAndActionsWrapper = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FolderPreviewWrapper = styled.div<{ isPending?: boolean }>`
  filter: drop-shadow(0 1px 5px rgba(41, 42, 43, 0.1));
  ${({ isPending }) =>
    isPending &&
    css`
      &:after {
        content: '';
        ${stretchBlock}
        background: #fff;
        z-index: 2;
        opacity: 0.5;
      }
    `}
`;
